import React from 'react';
import LocalStorage from '../../providers/LocalStorage';
import { Grid, Checkbox, Divider, TextField, FormControl, Select, Input, MenuItem, InputLabel, Button, Hidden } from '@material-ui/core';
// import noImg from '../../Pics/noImg.jpeg'
import { listTari } from './ListeComune';
// import completatorBkg from '../../Pics/completatorBkg.jpg'
import UtilsChestionare from './UtilsChestionare';
import AlertChestionar from './AlertChestionar';
import WsC from './providers/WsC';
import './ChestionareCss.css'

export default class CompletatorChestionar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            strBackgroundImage: null,
            nrIdBeneficiar: null,
            objectBeneficiar: {},
            objectHead: {},
            listIntrebari: [],
            listOptiuniRaspuns: [],
            sex: ['Masculin', 'Feminin', 'Neutru'],
            isOpenAlert: false,
            listTari: listTari,
            listStudii: new UtilsChestionare().studii,
            terenRealizat: null,
            varstaClase: new UtilsChestionare().varstaClase,
            venituriClase: new UtilsChestionare().venituriClase,
            message: '',
            chestionar: {},
            evaluare: {},
            anonim: false,
            acordAplicatie: false,
            acordChestionar: false,
            isOpenAlert2: false,
            isReadOnly: false,
            countDown: 0,
            isReadOnlyNume: false

        }
    }

    componentDidMount() {
        this.getInvitatie()

    }


    componentWillUnmount() {
        clearInterval(this.intervalID)
    }


    ws = new WsC()
    ls = new LocalStorage().GetUserData()

    intervalId;

    checkAndLogin = async () => {



        let u = new UtilsChestionare();
        let loginServerResponse = await this.ws.login({ email: 'anonim@anonim.ro', parolac: 'anonim266646' });
        // let loginServerResponse = await WS.postData('Login/Loginup',{email:this.state.strEmail, parolac:this.state.strP})
        // console.log('loginServerResponse = ', loginServerResponse)


        if (loginServerResponse.Succes) {

            let data = loginServerResponse.Content.UserData
            data.UserToken = loginServerResponse.Content.UserToken

            //  console.log('Data :', data);

            if (data.IsOnFiledAgent) {
                data.TipLogare = u.tipLogare.teren
            } else if (data.IsAnonim) {
                data.TipLogare = u.tipLogare.anonim
            } else if (data.EsteMagazin) {
                data.TipLogare = u.tipLogare.magazin
            } else {
                data.TipLogare = u.tipLogare.back_office
            }


            new LocalStorage().SetUserData(data)

            // console.log('All right simulare save = ')



        } else {
            this.setState({ labRez: loginServerResponse.Message })
        }
        // let toSave = {idUser:'777', nume:'Popescu'}

    }

    handleChange = (id) => ev => {

        let oldState = [...this.state.listOptiuniRaspuns]

        //console.log('oldState[id] :', oldState[id]);
        oldState[id].raspuns = ev.target.value
        this.setState({
            listOptiuniRaspuns: oldState,
        }, () => {

        });
    };

    handleMotivatie = (id) => ev => {
        let oldState = [...this.state.listOptiuniRaspuns]

        //  console.log('oldState[id] :', oldState[id]);

        let idx = oldState.findIndex(i => i.id === id)

        oldState[idx].motivatie_raspuns = ev.target.value
        this.setState({
            listOptiuniRaspuns: oldState,
        }, () => {

        });
    }
    handleHead = name => ev => {

        let oldState = { ...this.state.objectHead }


        oldState[name] = ev.target.value
        this.setState({
            objectHead: oldState,
        }, () => {

        });
    };




    getTime = async () => {

        let remainingTime = await this.ws.getData('Evaluari/GetRemainingTime', { hashId: this.props.match.params.idinvitatie })

        if (remainingTime.Succes) {
            console.log('remainingTime :>> ', remainingTime);

            if (remainingTime.Content[0].minute_ramase <= 0) {
                this.setState({
                    countDown: 0,
                    isReadOnly: true
                })
            } else {
                this.setState({ countDown: remainingTime.Content[0].minute_ramase }, () => {
                    this.startCronometru()
                })
            }


        }
    }



    colorMinuteRamase = () => {
        if (this.state.countDown > 10) {
            return 'rgb(128, 205, 90)'
        } else if (this.state.countDown < 10 && this.state.countDown > 5) {
            return 'darkorange'
        } else {
            return '#e00909'
        }
    }



    scurgereMinute = () => {

        console.log('scurgereMinute :>> ');


        if (this.state.countDown - 1 === 0) {
            this.setState({
                isReadOnly: true,
                countDown: this.state.countDown - 1
            })

        } else if (this.state.countDown <= 0) {
            this.setState({ isReadOnly: true, })
        }

        else {

            this.setState({ countDown: this.state.countDown - 1 })
        }

    }


    startCronometru = () => {

        this.intervalId = setInterval(this.scurgereMinute, 60000)

    }



    getInvitatie = async () => {


        let ls = new LocalStorage();





        if (!ls.GetUserData()) {
            await this.checkAndLogin()
        }




        // let _beneficiar = ws.customSelect('select * from beneficiari where id = @p1', {
        //     p1: invitatie.Content[0].id_beneficiar
        // });

        let _chestionar = this.ws.customSelect('select * from raspunsuri_head where hash_id = @p1', {
            p1: this.props.match.params.idinvitatie
        })












        let [chestionar] = await Promise.all([_chestionar])

        console.log('chestionar :', chestionar);

        let ses = {}

        if (chestionar.Succes) {

            if (chestionar.Content[0].tip_cronometru === 'la_lansare') {
                this.getTime()
            } else if (chestionar.Content[0].tip_cronometru === 'la_deschidere') {
                if (chestionar.Content[0].cand_start) {
                    this.getTime()

                } else {
                    let startCronometru = await this.ws.getData('Evaluari/StartCronometruRaspunsuriHead', { hashId: this.props.match.params.idinvitatie })

                    if (startCronometru.Succes) {
                        this.getInvitatie()
                    }

                }
            }

            console.log('chestionar.Content[0] :>> ', chestionar.Content[0]);

            let evaluare = await this.ws.customSelect('select * from evaluari where id = @p1', {
                p1: chestionar.Content[0].id_evaluare
            })

            let EvaluareStat

            if (evaluare.Succes) {
                let sesiune = await this.ws.customSelect('select * from sesiuni where id = @p1', {
                    p1:evaluare.Content[0].id_sesiune
                })
    
                console.log('sesiune :>> ', sesiune);


                if(sesiune.Succes){



                    if(sesiune.Content[0].finalizat === 1){
                        this.setState({
                            isOpenAlert: true,
                            message: 'Acest chestionar nu mai este valabil'
                        })

                        return false
                    }else{
                        ses = sesiune.Content.length > 0 ? sesiune.Content[0] : {}
                    }
                }
            }


       





            if (chestionar.Content[0].statusul !== 'Finalizat') {

                console.log('this.ls.InfoUser.Database :>> ', ses);

          

    let q2 = `select e.* , a.nume as nume_user from evaluari e left join [${ses.baza_date}].[dbo].[angajati] a on a.id_user = e.id_user_aprobare
      where e.id = @p1`


                let _evaluare = this.ws.customSelect(q2, {
                    p1: chestionar.Content[0].id_evaluare
                })


                let _realizatChestionar = this.ws.customSelect('select * from chestionare_teren_useri_asignati where id_chestionar = @p1 and id_user = @p2 ', {
                    p1: chestionar.Content[0].id_chestionar,
                    p2: chestionar.Content[0].id_user_teren || 0
                })




                // console.log('chestionar :', chestionar.Content);

                let _raspunsuri = this.ws.customSelect('select * from raspunsuri_intrebari where id_head = @p1 and isnull(sters,0) != 1 order by isnull(ordinea,0) asc, id_intrebare, id ', {
                    p1: chestionar.Content[0].id
                })

                let _optiuniRaspuns = this.ws.customSelect('select * from raspunsuri_intrebari_raspunsuri where id_head = @p1 order by id_optiune_raspuns', {
                    p1: chestionar.Content[0].id
                })

                let [raspunsuri, optiuniRaspuns, realizatChestionar, evaluare] = await Promise.all([_raspunsuri, _optiuniRaspuns, _realizatChestionar, _evaluare])

                // console.log('realizatChestionar :', realizatChestionar);

                if (raspunsuri.Succes && optiuniRaspuns.Succes && realizatChestionar.Succes) {



             


                    console.log('evaluare :>> ', evaluare);
                    //  console.log('raspunsuri :', raspunsuri);
                    console.log('optiuniRaspuns :', optiuniRaspuns);

                    let cloneIntrebari = [...raspunsuri.Content]


                    // console.log('cloneIntrebari :', cloneIntrebari);

                    let grupaj = cloneIntrebari.filter(c => c.id_parent > 0)



                    cloneIntrebari = cloneIntrebari.filter(c => c.id_parent === null || c.id_parent === 0)


                    // console.log('cloneIntrebari 1 ----- :', cloneIntrebari);

                    // console.log('grupaj :', grupaj);


                    for (let i = 0, n = cloneIntrebari.length; i < n; i++) {

                        if (cloneIntrebari[i].tip === 'grupaj' && ((cloneIntrebari[i].id_parent === null) || (cloneIntrebari[i].id_parent === 0))) {
                            // console.log('enter Here :');
                            cloneIntrebari[i].subintrebari = grupaj.filter(g => Number(g.id_parent) === Number(cloneIntrebari[i].id_intrebare))
                            // cloneIntrebari[i].subintrebari = cloneIntrebari[i].subintrebari.sort((a,b) =>{

                            // })

                        } else if (cloneIntrebari[i].tip === 'subintrebare' && ((cloneIntrebari[i].id_parent === null) || (cloneIntrebari[i].id_parent === 0))) {
                            // console.log('enterHere2 :');
                            cloneIntrebari[i].subintrebari = grupaj.filter(g => Number(g.id_parent) === Number(cloneIntrebari[i].id_intrebare))
                        }
                    }

                    console.log('cloneIntrebari :', cloneIntrebari);
                    // console.log('listOptiuniRaspuns :', optiuniRaspuns.Content);

                    let cloneObjHead = { ...chestionar.Content[0] }
                    cloneObjHead.tara = 'Romania'

                    console.log('evaluare :>> ', evaluare);
                    this.setState({
                        // strBackgroundImage: beneficiar.Content[0].backgroundimage,
                        // objectBeneficiar: beneficiar.Content[0],
                        // nrIdBeneficiar: beneficiar.Content[0].id,
                        evaluare: evaluare.Content.length > 0 ? evaluare.Content[0] : [],
                        chestionar: chestionar.Content[0],
                        terenRealizat: chestionar.Content[0].pe_teren === 1 ? realizatChestionar.Content[0] : null,
                        objectHead: cloneObjHead,
                        listIntrebari: cloneIntrebari,
                        listOptiuniRaspuns: optiuniRaspuns.Content,
                        isReadOnly: chestionar.Content[0].tip_cronometru ? this.state.isReadOnly : (chestionar.Content[0].statusul !== 'Finalizat' ? false : true),
                        isReadOnlyNume: chestionar.Content[0].statusul !== 'Finalizat' ? false : true
                    })
                }

            } else {

                console.log('chestionar.Content[0] :>> ', chestionar.Content[0]);
            
                    this.setState({
                        isOpenAlert: true,
                        message: 'Va multumim pentru completarea acestui chestionar'
                    })
                


            }




        }
    }



    getValue = id => ev => {
        // console.log('ev.target.value :', ev.target.value);
        // console.log('object :', id);

        let idOptiune = Number(ev.target.value)
        let cloneOptiuniRaspuns = this.state.listOptiuniRaspuns

        let filterOptiuni = cloneOptiuniRaspuns.filter(c => c.id_intrebare === id)

        // console.log('filterOptiuni :', filterOptiuni);

        // let idOption = filterOptiuni.findIndex(c => c.id_optiune_raspuns === idOptiune)





        let counter = filterOptiuni.length

        for (let i = 0; i < counter; i++) {
            let idx = this.state.listOptiuniRaspuns.findIndex(fo => fo.id_optiune_raspuns === filterOptiuni[i].id_optiune_raspuns)

            if (this.state.listOptiuniRaspuns[idx].id_optiune_raspuns === idOptiune) {
                cloneOptiuniRaspuns[idx].raspuns = cloneOptiuniRaspuns[idx].label_optiune_raspuns
            } else {
                cloneOptiuniRaspuns[idx].raspuns = null
            }
        }

        let raspuns = cloneOptiuniRaspuns.filter(c => c.id_optiune_raspuns === idOptiune)
        // console.log('filterOptiuni[idx] :', raspuns);

        this.setState({ listOptiuniRaspuns: cloneOptiuniRaspuns }, async () => {


            if (this.state.objectHead.pe_teren === 1) {
                let checkRaspuns = await this.ws.raspunsTeren(raspuns[0], 'radio', this.props.match.params.idinvitatie, this.state.objectHead.id)

                // console.log('this.state.objectHead.id :', this.state.objectHead.id);
                // console.log('checkRaspuns :', checkRaspuns);
                if (checkRaspuns.Succes) {


                }
            } else {

                let checkRaspuns = await this.ws.raspunsGuest(raspuns[0], 'radio', this.props.match.params.idinvitatie, this.state.objectHead.id)

                // console.log('this.state.objectHead.id :', this.state.objectHead.id);
                //  console.log('checkRaspuns :', checkRaspuns);
                if (checkRaspuns.Succes) {


                }
            }


        })


    }

    handleCheck = id => ev => {
        //  console.log('ev.target.checked :', ev.target.checked);

        let cloneOptiuniRaspuns = this.state.listOptiuniRaspuns

        let idx = cloneOptiuniRaspuns.findIndex(i => i.id_optiune_raspuns === id)

        cloneOptiuniRaspuns[idx].raspuns = ev.target.checked === true ? 'true' : 'false'

        //  console.log('cloneRaspuns[idx] :', cloneOptiuniRaspuns[idx]);


        this.setState({ listOtiuniRaspuns: cloneOptiuniRaspuns }, async () => {


            if (this.state.objectHead.pe_teren === 1) {
                let checkRaspuns = await this.ws.raspunsTeren(cloneOptiuniRaspuns[idx], 'checkbox', this.props.match.params.idinvitatie, this.state.objectHead.id)

                //   console.log('this.state.objectHead.id :', this.state.objectHead.id);
                //  console.log('checkRaspuns :', checkRaspuns);
                if (checkRaspuns.Succes) {


                }
            } else {

                let checkRaspuns = await this.ws.raspunsGuest(cloneOptiuniRaspuns[idx], 'checkbox', this.props.match.params.idinvitatie, this.state.objectHead.id)

                //  console.log('this.state.objectHead.id :', this.state.objectHead.id);
                //  console.log('checkRaspuns :', checkRaspuns);
                if (checkRaspuns.Succes) {


                }
            }
        })




    }

    onTextBlur = async (i) => {

        //  console.log('i :', i);


        if (this.state.objectHead.pe_teren === 1) {
            let checkRaspuns = await this.ws.raspunsTeren(i, 'text', this.props.match.params.idinvitatie, this.state.objectHead.id)

            //  console.log('this.state.objectHead.id :', this.state.objectHead.id);
            // console.log('checkRaspuns :', checkRaspuns);
            if (checkRaspuns.Succes) {


            }
        } else {

            let checkRaspuns = await this.ws.raspunsGuest(i, 'text', this.props.match.params.idinvitatie, this.state.objectHead.id)

            //  console.log('this.state.objectHead.id :', this.state.objectHead.id);
            //  console.log('checkRaspuns :', checkRaspuns);
            if (checkRaspuns.Succes) {


            }
        }


    }


    onMotivatieBlur = async (i) => {
        //   console.log('i :', i);



        let updateMotivatie = await this.ws.update('raspunsuri_intrebari_raspunsuri', { motivatie_raspuns: i.motivatie_raspuns || '' }, { id: i.id })

        if (updateMotivatie.Succes) {
            //    console.log('updated :');
        }

    }



    mapIntrebari = () => {



        let intrebari = this.state.listIntrebari



        //  console.log('intrebari :', intrebari);

        let counter = intrebari.length

        let container = []

        let intrebare = []

        for (let i = 0; i < counter; i++) {



            //  console.log('intrebari[i] :', intrebari[i]);
            if (intrebari[i].tip === 'radio') {

                let raspunsuriClone = this.state.listOptiuniRaspuns

                let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(intrebari[i].id_intrebare))

                //  console.log('raspunsuri :', i, raspunsuri);
                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}> {i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(O singura varianta de raspuns)</span>
                    <div>
                        {raspunsuri.map((r, ix) => {

                            return (
                                <div className='chestionare-optiuni-raspuns' key={ix}>

                                    <Checkbox
                                        style={{ color: '#80cd5a' }}
                                        disabled={this.state.isReadOnly}
                                        checked={r.label_optiune_raspuns === r.raspuns}
                                        onChange={this.getValue(r.id_intrebare)}
                                        value={r.id_optiune_raspuns.toString()}
                                    />
                                    {/* <Radio
                                            name={intrebari[i].intrebare}
                                            checked={r.label_optiune_raspuns === r.raspuns}
                                            onChange={}
                                            value={r.id_optiune_raspuns}
                                           
                                            aria-label={r.id_optiune_raspuns}
                                            />  */}
                                    <span className='chestionare-raspunsuri-options' style={{
                                        fontSize: 16,
                                        fontWeight: 600,

                                    }}>{r.label_optiune_raspuns}</span>
                                </div>
                            )
                        })}
                    </div>

                    <Divider className="crm-divider" />
                </Grid>]
            } else if (intrebari[i].tip === 'checkbox') {
                let raspunsuriClone = this.state.listOptiuniRaspuns

                let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(intrebari[i].id_intrebare))

                //   console.log('raspunsuri :', i, raspunsuri);

                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}>{i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(Mai multe variante de raspuns)</span>
                    <div>
                        {raspunsuri.map((r, ix) => {

                            return (
                                <div className='chestionare-optiuni-raspuns' key={ix}>

                                    <Checkbox
                                        style={{ color: 'rgb(90 176 205)' }}
                                        disabled={this.state.isReadOnly}
                                        checked={r.raspuns === 'true' ? true : false}
                                        onChange={this.handleCheck(r.id_optiune_raspuns)}
                                        value="checkedA"
                                    />
                                    <span className='chestionare-raspunsuri-options' style={{
                                        fontSize: 16,
                                        fontWeight: 600,

                                    }}>{r.label_optiune_raspuns}</span>
                                </div>
                            )
                        })}
                    </div>



                    <Divider className="crm-divider" />
                </Grid>]

            }
            else if (intrebari[i].tip === 'motivatie_radio') {

                let raspunsuriClone = this.state.listOptiuniRaspuns

                let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(intrebari[i].id_intrebare))

                // console.log('raspunsuri :', i, raspunsuri);
                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}> {i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(O singura varianta de raspuns)</span>
                    <div>
                        {raspunsuri.map((r, ix) => {

                            return (
                                <div className='chestionare-optiuni-raspuns' key={ix}>

                                    <Checkbox
                                        style={{ color: '#80cd5a' }}
                                        disabled={this.state.isReadOnly}
                                        checked={r.label_optiune_raspuns === r.raspuns}
                                        onChange={this.getValue(r.id_intrebare)}
                                        value={r.id_optiune_raspuns.toString()}
                                    />
                                    {/* <Radio
                                            name={intrebari[i].intrebare}
                                            checked={r.label_optiune_raspuns === r.raspuns}
                                            onChange={}
                                            value={r.id_optiune_raspuns}
                                           
                                            aria-label={r.id_optiune_raspuns}
                                            />  */}
                                    <span className='chestionare-raspunsuri-options' style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                    }}>{r.label_optiune_raspuns}</span>

                                    <TextField
                                        disabled={this.state.isReadOnly}
                                        className="loginTextField inputFocus"

                                        onBlur={() => { this.onMotivatieBlur(raspunsuri[ix]) }}
                                        style={{ marginLeft: 10, verticalAlign: 'initial' }}
                                        label={intrebari[i].motivatie_label}
                                        margin="normal"
                                        value={raspunsuri[ix].motivatie_raspuns || ''}
                                        onChange={this.handleMotivatie(raspunsuri[ix].id)}
                                        type='text'

                                    />
                                </div>
                            )
                        })}
                    </div>

                    <Divider className="crm-divider" />
                </Grid>]
            }
            else if (intrebari[i].tip === 'motivatie_checkbox') {
                let raspunsuriClone = this.state.listOptiuniRaspuns

                let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(intrebari[i].id_intrebare))

                // console.log('raspunsuri :', i, raspunsuri);

                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17 }}>{i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(Mai multe variante de raspuns)</span>
                    <div>
                        {raspunsuri.map((r, ix) => {

                            return (
                                <div className='chestionare-optiuni-raspuns' key={ix}>

                                    <Checkbox
                                        style={{ color: '#80cd5a' }}
                                        disabled={this.state.isReadOnly}
                                        checked={r.raspuns === 'true' ? true : false}
                                        onChange={this.handleCheck(r.id_optiune_raspuns)}
                                        value="checkedA"
                                    />
                                    <span className='chestionare-raspunsuri-options' style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                    }}>{r.label_optiune_raspuns}</span>

                                    <TextField
                                        disabled={this.state.isReadOnly}
                                        className="loginTextField inputFocus"

                                        onBlur={() => { this.onMotivatieBlur(raspunsuri[ix]) }}
                                        style={{ marginLeft: 10, verticalAlign: 'initial' }}
                                        label={intrebari[i].motivatie_label}
                                        margin="normal"
                                        value={raspunsuri[ix].motivatie_raspuns || ''}
                                        onChange={this.handleMotivatie(raspunsuri[ix].id)}
                                        type='text'

                                    />
                                </div>
                            )
                        })}

                    </div>



                    <Divider className="crm-divider" />
                </Grid>]

            }
            else if (intrebari[i].tip === 'subintrebare') {

                let raspunsuriClone = this.state.listOptiuniRaspuns
                //  console.warn('intrebari[i] :', intrebari[i]);

                //  console.log('raspunsuriClone :', raspunsuriClone);
                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17 }}> {i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <div>

                        {intrebari[i].subintrebari.map((g, idx) => {
                            let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(g.id_intrebare))

                            if (g.tip === 'radio') {
                                return (
                                    <Grid key={idx} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                                        <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}> {i + 1 + '. ' + (idx + 1) + '. ' + g.intrebare}</p>
                                        <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(O singura varianta de raspuns)</span>
                                        <div>
                                            {raspunsuri.map((r, ix) => {

                                                return (
                                                    <div className='chestionare-optiuni-raspuns' key={ix}>

                                                        <Checkbox
                                                            style={{ color: '#80cd5a' }}
                                                            disabled={this.state.isReadOnly}
                                                            checked={r.label_optiune_raspuns === r.raspuns}
                                                            onChange={this.getValue(r.id_intrebare)}
                                                            value={r.id_optiune_raspuns.toString()}
                                                        />
                                                        {/* <Radio
                                            name={intrebari[i].intrebare}
                                            checked={r.label_optiune_raspuns === r.raspuns}
                                            onChange={}
                                            value={r.id_optiune_raspuns}
                                           
                                            aria-label={r.id_optiune_raspuns}
                                            />  */}
                                                        <span className='chestionare-raspunsuri-options' style={{
                                                            fontSize: 16,
                                                            fontWeight: 600,
                                                        }}>{r.label_optiune_raspuns}</span>


                                                    </div>
                                                )
                                            })}
                                        </div>

                                        <Divider className="crm-divider" />
                                    </Grid>
                                )
                            } else if (g.tip === 'checkbox') {

                                return (<Grid key={idx} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}>{i + 1 + '. ' + (idx + 1) + '. ' + g.intrebare}</p>
                                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(Mai multe variante de raspuns)</span>
                                    <div>
                                        {raspunsuri.map((r, ix) => {

                                            return (
                                                <div className='chestionare-optiuni-raspuns' key={ix}>

                                                    <Checkbox
                                                        style={{ color: 'rgb(90 176 205)' }}
                                                        disabled={this.state.isReadOnly}
                                                        checked={r.raspuns === 'true' ? true : false}
                                                        onChange={this.handleCheck(r.id_optiune_raspuns)}
                                                        value="checkedA"
                                                    />
                                                    <span className='chestionare-raspunsuri-options' style={{
                                                        fontSize: 16,
                                                        fontWeight: 600,
                                                    }}>{r.label_optiune_raspuns}</span>


                                                </div>
                                            )
                                        })}

                                    </div>



                                    <Divider className="crm-divider" />
                                </Grid>)

                            } else if (g.tip === 'motivatie_radio') {
                                return (<Grid key={idx} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}> {i + 1 + '. ' + (idx + 1) + '. ' + g.intrebare}</p>
                                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(O singura varianta de raspuns)</span>
                                    <div>
                                        {raspunsuri.map((r, ix) => {

                                            return (
                                                <div className='chestionare-optiuni-raspuns' key={ix}>

                                                    <Checkbox
                                                        style={{ color: '#80cd5a' }}
                                                        disabled={this.state.isReadOnly}
                                                        checked={r.label_optiune_raspuns === r.raspuns}
                                                        onChange={this.getValue(r.id_intrebare)}
                                                        value={r.id_optiune_raspuns.toString()}
                                                    />
                                                    {/* <Radio
                                                        name={intrebari[i].intrebare}
                                                        checked={r.label_optiune_raspuns === r.raspuns}
                                                        onChange={}
                                                        value={r.id_optiune_raspuns}
                                                       
                                                        aria-label={r.id_optiune_raspuns}
                                                        />  */}
                                                    <span className='chestionare-raspunsuri-options' style={{
                                                        fontSize: 16,
                                                        fontWeight: 600
                                                    }}>{r.label_optiune_raspuns}</span>

                                                    <TextField
                                                        disabled={this.state.isReadOnly}
                                                        className="loginTextField inputFocus"

                                                        onBlur={() => { this.onMotivatieBlur(raspunsuri[ix]) }}
                                                        style={{ marginLeft: 10, verticalAlign: 'initial' }}
                                                        label={g.motivatie_label}
                                                        margin="normal"
                                                        value={raspunsuri[ix].motivatie_raspuns || ''}
                                                        onChange={this.handleMotivatie(raspunsuri[ix].id)}
                                                        type='text'

                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>

                                    <Divider className="crm-divider" />
                                </Grid>)
                            } else if (g.tip === 'motivatie_checkbox') {
                                return (<Grid key={idx} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}>{i + 1 + '. ' + (idx + 1) + '. ' + g.intrebare}</p>
                                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(Mai multe variante de raspuns)</span>
                                    <div>
                                        {raspunsuri.map((r, ix) => {

                                            return (
                                                <div className='chestionare-optiuni-raspuns' key={ix}>

                                                    <Checkbox
                                                        style={{ color: '#80cd5a' }}
                                                        disabled={this.state.isReadOnly}
                                                        checked={r.raspuns === 'true' ? true : false}
                                                        onChange={this.handleCheck(r.id_optiune_raspuns)}
                                                        value="checkedA"
                                                    />
                                                    <span className='chestionare-raspunsuri-options' style={{
                                                        fontSize: 16,
                                                        fontWeight: 600,
                                                    }}>{r.label_optiune_raspuns}</span>

                                                    <TextField
                                                        disabled={this.state.isReadOnly}
                                                        className="loginTextField inputFocus"

                                                        onBlur={() => { this.onMotivatieBlur(raspunsuri[ix]) }}
                                                        style={{ marginLeft: 10, verticalAlign: 'initial' }}
                                                        label={g.motivatie_label}
                                                        margin="normal"
                                                        value={raspunsuri[ix].motivatie_raspuns || ''}
                                                        onChange={this.handleMotivatie(raspunsuri[ix].id)}
                                                        type='text'

                                                    />
                                                </div>
                                            )
                                        })}

                                    </div>



                                    <Divider className="crm-divider" />
                                </Grid>)
                            }

                        })}


                    </div>

                    <Divider className="crm-divider" />
                </Grid>]



            }
            else if (intrebari[i].tip === 'img_multiple') {
                let raspunsuriClone = this.state.listOptiuniRaspuns

                let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(intrebari[i].id_intrebare))

                //  console.log('raspunsuri :', i, raspunsuri);

                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}>{i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(Mai multe variante de raspuns)</span>
                    <div>
                        {raspunsuri.map((r, ix) => {

                            return (
                                <div style={{ marginBottom: 10 }} className='chestionare-optiuni-raspuns' key={ix}>

                                    <Checkbox
                                        style={{ color: 'rgb(90 176 205)' }}
                                        disabled={this.state.isReadOnly}
                                        checked={r.raspuns === 'true' ? true : false}
                                        onChange={this.handleCheck(r.id_optiune_raspuns)}
                                        value="checkedA"
                                    />
                                    <span className='chestionare-raspunsuri-options'>
                                        {r.img_src &&
                                            <img alt={r.img_src} style={{ maxWidth: '80%', verticalAlign: 'middle' }} src={this.ws.adresaMedia + `/Chestionare/Raspunsuri_img/${r.img_src}`} />
                                        }

                                        {!r.img_src &&
                                            <span style={{ marginLeft: 10, display: 'block' }} >
                                                {ix + 1}.  <i className='material-icons'>image</i></span>
                                        }


                                    </span>
                                </div>
                            )
                        })}
                    </div>



                    <Divider className="crm-divider" />
                </Grid>]
            }

            else if (intrebari[i].tip === 'img_single') {
                let raspunsuriClone = this.state.listOptiuniRaspuns

                let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(intrebari[i].id_intrebare))

                //  console.log('raspunsuri :', i, raspunsuri);
                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginBottom: 0 }}> {i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(O singura varianta de raspuns)</span>
                    <div>
                        {raspunsuri.map((r, ix) => {

                            return (
                                <div style={{ marginBottom: 10 }} className='chestionare-optiuni-raspuns' key={ix}>

                                    <Checkbox
                                        style={{ color: '#80cd5a' }}
                                        disabled={this.state.isReadOnly}
                                        checked={r.label_optiune_raspuns === r.raspuns}
                                        onChange={this.getValue(r.id_intrebare)}
                                        value={r.id_optiune_raspuns.toString()}
                                    />
                                    {/* <Radio
                                            name={intrebari[i].intrebare}
                                            checked={r.label_optiune_raspuns === r.raspuns}
                                            onChange={}
                                            value={r.id_optiune_raspuns}
                                           
                                            aria-label={r.id_optiune_raspuns}
                                            />  */}
                                    <span className='chestionare-raspunsuri-options'>
                                        {r.img_src &&
                                            <img alt={r.img_src} style={{ maxWidth: '80%', verticalAlign: 'middle' }} src={this.ws.adresaMedia + `/Chestionare/Raspunsuri_img/${r.img_src}`} />
                                        }

                                        {!r.img_src &&
                                            <span style={{ marginLeft: 10 }} >
                                                <i className='material-icons'>image</i></span>
                                        }


                                    </span>
                                </div>
                            )
                        })}
                    </div>


                    <Divider className="crm-divider" />
                </Grid>]
            }

            else if (intrebari[i].tip === 'grupaj') {
                let raspunsuriClone = this.state.listOptiuniRaspuns

                //  console.log('raspunsuriClone :', raspunsuriClone);
                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17 }}> {i + 1 + '. ' + intrebari[i].intrebare}</p><br />

                    <div>

                        {intrebari[i].subintrebari.map((g, idx) => {
                            let raspunsuri = raspunsuriClone.filter(r => r.id_intrebare === Number(g.id_intrebare))
                            console.log('g :>> ', g);

                            return (
                                <div style={{ textAlign: 'left', paddingLeft: 20 }} key={idx}>
                                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17, marginTop: 0, display: 'inline-block', marginBottom: 0 }}> {i + 1 + '. ' + (idx + 1) + '. ' + g.intrebare}</p>
                                    <span style={{ display: 'block', textAlign: 'left', fontSize: 12, color: 'gray' }}>(O singura varianta de raspuns)</span>
                                    {raspunsuri.map((r, idx2) => {
                                        return (
                                            <div style={{ display: 'inline-block', marginLeft: idx2 === 0 ? 0 : '' }} className='chestionare-optiuni-raspuns' key={idx2}>

                                                <Checkbox
                                                    style={{ color: '#80cd5a' }}
                                                    disabled={this.state.isReadOnly}
                                                    checked={r.label_optiune_raspuns === r.raspuns}
                                                    onChange={this.getValue(r.id_intrebare)}
                                                    value={r.id_optiune_raspuns.toString()}
                                                />
                                                {/* <Radio
        name={intrebari[i].intrebare}
        checked={r.label_optiune_raspuns === r.raspuns}
        onChange={}
        value={r.id_optiune_raspuns}
       
        aria-label={r.id_optiune_raspuns}
        />  */}
                                                <span className='chestionare-raspunsuri-options' style={{
                                                    fontSize: 16,
                                                    fontWeight: 600,
                                                    color: '#425d92'
                                                }}>{r.label_optiune_raspuns}</span>
                                            </div>
                                        )

                                    })}

                                </div>
                            )
                        })}


                    </div>

                    <Divider className="crm-divider" />
                </Grid>]


            }
            else {
                let raspunsuriClone = this.state.listOptiuniRaspuns

                console.log('raspunsuriClone :', raspunsuriClone);

                //console.log('intrebari[i] :', intrebari[i]);

                let raspunsuri = raspunsuriClone.filter(r =>Number(r.id_intrebare) === Number(intrebari[i].id_intrebare))

                // console.log('raspunsuri :', i, raspunsuri);

               
console.log('raspunsuri :>> ', raspunsuri);

                let idx = this.state.listOptiuniRaspuns.findIndex(c => c.id_intrebare === raspunsuri[0].id_intrebare)

                //console.log('this.state.optiuniRaspuns[idx] :', this.state.listOptiuniRaspuns[idx]);

                intrebare = [<Grid key={i} item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>
                    <p className='chestionare-intrebare-label' style={{ fontWeight: 500, fontSize: 17 }}> {i + 1 + '. ' + intrebari[i].intrebare}</p>
                    <TextField
                        disabled={this.state.isReadOnly}
                        className="loginTextField inputFocus"

                        onBlur={() => { this.onTextBlur(this.state.listOptiuniRaspuns[idx]) }}
                        style={{ width: '100%' }}
                        // label={i + 1 + '. ' + intrebari[i].intrebare}
                        margin="normal"
                        value={this.state.listOptiuniRaspuns[idx].raspuns || ''}
                        onChange={this.handleChange(idx)}
                        type='text'

                    />




                    <Divider className="crm-divider" />
                </Grid>]
            }

            container.push(intrebare)


        }

        return container


    }

    finalizeaza = async () => {

        let ls = new LocalStorage().GetUserData();

        let u = new UtilsChestionare().tipLogare;

        // console.log('this.state.objectHead :', this.state.objectHead);
        // console.log('this.state.terenRealizat :', this.state.terenRealizat);


        await this.ws.sendNotification(this.state.chestionar.id_chestionar, this.state.evaluare.id, 'completare')

        // console.log('notif :>> ', notif);



        // console.log('this.state.evaluare :>> ', this.state.evaluare);

        if (this.state.evaluare.tip === 'chestionare_magazin') {

            let _finalizeaza = this.ws.finalizeazaChestionar(this.props.match.params.idinvitatie, this.state.objectHead.id)
            let _addRealizat = this.ws.update('chestionare_teren_useri_asignati',
                { nr_completari_realizate: this.state.terenRealizat.nr_completari_realizate !== null ? this.state.terenRealizat.nr_completari_realizate + 1 : 1 },
                { id: this.state.terenRealizat.id })

            let [finalizeaza, addRealizat] = await Promise.all([_finalizeaza, _addRealizat])
            // console.log('addRealizat :', addRealizat);
            // console.log('finalizeaza :', finalizeaza);
            if (addRealizat.Succes && finalizeaza.Succes) {

                this.setState({
                    isOpenAlert: true,
                    message: 'Va multumim pentru completarea acestui chestionar'
                }, () => {
                    this.props.history.goBack()

                })


            }
        }

        else if (this.state.objectHead.pe_teren === 1) {

            // console.log('estePe Teren :>> ',);

            // console.log('this.state.objectHead :', this.state.objectHead);
            // console.log('terenRealizat :', this.state.terenRealizat);

            // console.log('terenRealizat true :', true);
            let _finalizeaza = this.ws.finalizeazaChestionar(this.props.match.params.idinvitatie, this.state.objectHead.id)
            let _addRealizat = this.ws.update('chestionare_teren_useri_asignati',
                { nr_completari_realizate: this.state.terenRealizat.nr_completari_realizate !== null ? this.state.terenRealizat.nr_completari_realizate + 1 : 1 },
                { id: this.state.terenRealizat.id })

            let [finalizeaza, addRealizat] = await Promise.all([_finalizeaza, _addRealizat])
            // console.log('addRealizat :', addRealizat);
            // console.log('finalizeaza :', finalizeaza);
            if (addRealizat.Succes && finalizeaza.Succes) {

                this.setState({
                    isOpenAlert: true,
                    message: 'Va multumim pentru completarea acestui chestionar'
                }, () => {
                    this.props.history.goBack()

                })


            }


        } else {

            let finalizeaza = await this.ws.finalizeazaChestionar(this.props.match.params.idinvitatie, this.state.objectHead.id)

            if (finalizeaza.Succes) {
                if (ls.TipLogare === u.anonim) {

                    localStorage.removeItem('localUserKey')


                }

                this.setState({
                    isOpenAlert: true,
                    message: 'Va multumim pentru completarea acestui chestionar'
                }, () => {
                    window.location = 'https://tenews.ro/'
                })
            }

        }


    }

    updateHead = async () => {

        let headObj = {
            nume: this.state.objectHead.nume || "",
            prenume: this.state.objectHead.prenume || "",
            tara: this.state.objectHead.tara || "",
            mail: this.state.objectHead.mail || "",
            telefon: this.state.objectHead.telefon || "",
            varsta: this.state.objectHead.varsta || "",
            adresa: this.state.objectHead.adresa || "",
            sex: this.state.objectHead.sex || "",
            venituri: this.state.objectHead.venituri || "",
            studii: this.state.objectHead.studii || ""
        }




        await this.ws.update('raspunsuri_head', headObj, { id: this.state.objectHead.id })

        //  console.log('updateHead :', updateHead);


    }







    checkAnonim = (ev) => {


        this.setState({
            anonim: ev.target.checked,
            acordChestionar: false,
            acordAplicatie: false
        })
    }

    checkAcordChestionar = (ev) =>{
        this.setState({
            anonim: false,
            acordChestionar: ev.target.checked,
            acordAplicatie: false
        })
    }

    checkAcordAplicatie = (ev) =>{
        this.setState({
            anonim: false,
            acordChestionar:false,
            acordAplicatie:  ev.target.checked
        })
    }



    onAcordClick = () => {
        window.open('https://www.google.ro')
    }



    checkFinalizeaza = () => {




        if (this.state.anonim) {
            this.finalizeaza()
        } else if (this.state.acordChestionar) {
            this.finalizeaza()
        } else if (this.state.acordAplicatie) {
            this.finalizeaza()
        } else {
            this.setState({ isOpenAlert2: true })
        }


    }


    render() {
        return (
            <div className='chestionare-background-div' style={{ marginLeft: 0, marginTop: -50 }}>

                <div style={{ position: 'relative' }}>

                    <AlertChestionar
                        open={this.state.isOpenAlert}
                        dialogClose={() => { window.location = 'https://tenews.ro/' }}
                        title={this.state.message}
                        yesFunction={() => { window.location = 'https://tenews.ro/' }}
                        noButtonDisplay={1}
                    />


                    <AlertChestionar
                        open={this.state.isOpenAlert2}
                        dialogClose={() => { this.setState({ isOpenAlert2: false }) }}
                        title={'Te rog selecteaza una dintre optiunile din capul paginii . '}
                        yesFunction={() => { this.setState({ isOpenAlert2: false }) }}
                        noButtonDisplay={1}
                    />

                    <div style={{ maxWidth: 900, width: '100%', margin: 'auto' }}>

                        <h1 className='titleChestionar'>Completeaza Chestionar</h1>
                    </div>

                    {this.state.objectBeneficiar &&
                        <div style={{ position: 'relative', maxWidth: 900, margin: 'auto' }}>
                            {/* <div style={{ backgroundImage: `url(${this.state.objectBeneficiar.logo !== null ? `${new Ws().adresaMedia}Beneficiari/${this.state.objectBeneficiar.id}/${this.state.objectBeneficiar.logo}` : noImg})` }} className="chestionare-logo" id="poza-listare"  ></div> */}
                            <Grid container style={{ backgroundColor: 'white', padding: 20, width: '100%', maxWidth: 900, margin: 'auto', marginTop: 80, borderRadius: 30, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }} >

                                {this.state.evaluare.tip !== 'chestionare_cursuri' &&
                                    <Grid style={{ textAlign: 'left', margin: 0 }} item xs={12} sm={12} md={12} l={12} xl={12} >
                                        <Checkbox
                                            style={{ color: '#80cd5a' }}
                                            checked={this.state.anonim}
                                            onChange={this.checkAnonim}
                                            value={'anonim'}
                                        />


                                        <span className='chestionare-raspunsuri-options' style={{
                                            fontSize: 16,
                                            fontWeight: 600,
                                            color: 'black'
                                        }}>Vreau sa completez anonim</span>
                                    </Grid>
                                }


                                <Grid style={{ textAlign: 'left', margin: 0 }} item xs={12} sm={12} md={12} l={12} xl={12} >
                                    <Checkbox
                                       
                                        style={{ color: '#80cd5a' }}
                                        checked={this.state.acordChestionar}
                                        onChange={this.checkAcordChestionar}
                                        value={'acordChestionar'}
                                    />


                                    <span className='chestionare-raspunsuri-options' style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                        color: 'black'
                                    }}>Acord colectare date in chestionarul respectiv <span onClick={this.onAcordClick} style={{ color: 'blue' }}>aici</span> </span>
                                </Grid>

                                <Grid style={{ textAlign: 'left', margin: 0 }} item xs={12} sm={12} md={12} l={12} xl={12} >
                                    <Checkbox
                                        style={{ color: '#80cd5a' }}
                                     
                                        checked={this.state.acordAplicatie}
                                        onChange={this.checkAcordAplicatie}
                                        value={'acordAplicatie'}
                                    />


                                    <span className='chestionare-raspunsuri-options' style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                        color: 'black'
                                    }}>Acord colectare date in aplicatie <span onClick={this.onAcordClick} style={{ color: 'blue' }}>aici</span></span>
                                </Grid>


                                <Grid item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>

                                    <h3 className='cardTitle' style={{ marginBottom: 0}}>{this.state.objectHead.titlu_chestionar} </h3>
                                    <h5 style={{marginTop:0, textAlign:'left', marginBottom:20, fontWeight:400}}>Persoana evaluata - {this.state.evaluare.nume_user}</h5>
                                    {this.state.evaluare.tip === 'chestionare_cursuri' &&

                                        <h2 style={{ textAlign: 'left', color: this.colorMinuteRamase() }}>{this.state.countDown} minute</h2>
                                    }
                                    <Divider className="crm-divider" />
                                </Grid>

                                {this.mapIntrebari()}
                            </Grid>
                            <Grid container style={{ backgroundColor: 'white', marginBottom: 50, padding: 20, width: '100%', maxWidth: 900, margin: 'auto', borderRadius: 30, borderTopLeftRadius: 0, borderTopRightRadius: 0, }}  >

                               
                             

                                <Grid style={{ textAlign: 'right' }} item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >

                                    <Button style={{ marginTop: 20, maxWidth: 400, width: '90%', padding: '10px 40px 10px 40px' }} variant="outlined" onClick={this.checkFinalizeaza} className='chestionare-aproba-button'>
                                        Finalizeaza Chestionarul
                                    </Button>




                                </Grid>

                            </Grid>


                        </div>
                    }
                </div>

                <Hidden mdDown>

                    <div className='chestionare-footer'>
                        <span>Chestionare Online &copy; TotalSoftware.ro</span>
                    </div>
                </Hidden>
            </div>
        );
    }
}